import { displayResourcesAtom } from "@app/resources/atom";
import { Button } from "@design-system/ui/button";
import { cn } from "@design-system/utils";
import { trans, plainTrans } from "@mongez/localization";
import { Grid, List } from "lucide-react";

export function DisplayResourcesButtons() {
  const displayResources = displayResourcesAtom.useValue();

  return (
    <div className="flex items-center gap-1 rounded-xl border border-slate-200 bg-white p-1 shadow-sm dark:border-slate-700 dark:bg-slate-900">
      <Button
        variant="ghost"
        aria-label={plainTrans("grades.listView")}
        className={cn(
          "h-9 w-9 rounded-lg p-0",
          displayResources === "list"
            ? "bg-sky-500 text-white hover:bg-sky-600"
            : "text-slate-500 hover:bg-sky-50 hover:text-sky-600 dark:hover:bg-sky-950",
        )}
        onClick={() => {
          displayResourcesAtom.update("list");
        }}
      >
        <List className="h-5 w-5" />
      </Button>
      <Button
        variant="ghost"
        aria-label={plainTrans("grades.gridView")}
        className={cn(
          "h-9 w-9 rounded-lg p-0",
          displayResources === "grid"
            ? "bg-sky-500 text-white hover:bg-sky-600"
            : "text-slate-500 hover:bg-sky-50 hover:text-sky-600 dark:hover:bg-sky-950",
        )}
        onClick={() => {
          displayResourcesAtom.update("grid");
        }}
      >
        <Grid className="h-5 w-5" />
      </Button>
    </div>
  );
}
